import axios from "axios";
import store from "../store";

class StepInfo {
	async GetByName(name, lang = "FR") {
		let jwt = store.state.jwt;

		let result = await axios
			.get(`${`${process.env.VUE_APP_SAAS_BACK}`}/step_info/${name}`, {
				headers: { Authorization: "Bearer " + jwt },
			})
			.then((response) => {
				if (
					response.status === 200 &&
					response.data.stepInfo.length > 0
				) {
					// * mal géré le retour, tableau de tableaux...
					let stepsArray = response.data.stepInfo[0];

					let result = stepsArray.find((step) => step.lang === lang);

					return result === null || result === undefined
						? {}
						: result;
				}
				return {};
			})
			.catch((err) => {
				console.log("Error getting step info: ", err);
				return {};
			});

		return result;
	}

	async Create(stepInfo) {
		let jwt = store.state.jwt;

		let result = await axios
			.post(
				`${`${process.env.VUE_APP_SAAS_BACK}`}/step_info`,
				{
					stepInfo,
				},
				{
					headers: { Authorization: "Bearer " + jwt },
				}
			)
			.then((response) => {
				return response.data;
			})
			.catch((err) => {
				console.log("Error getting step info: ", err);
				return { err: err };
			});

		return result;
	}

	async Update(stepInfo) {
		let jwt = store.state.jwt;

		let result = await axios
			.put(
				`${`${process.env.VUE_APP_SAAS_BACK}`}/step_info/${stepInfo.name}/${stepInfo.lang}`,
				{
					stepInfo,
				},
				{
					headers: { Authorization: "Bearer " + jwt },
				}
			)
			.then((response) => {
				return response.data;
			})
			.catch((err) => {
				console.log("Error getting step info: ", err);
				return { err: err };
			});

		return result;
	}

	async CreateOrUpdate(stepInfo) {
		let existingStepInfo = await this.GetByName(
			stepInfo.name,
			stepInfo.lang
		);

		// * n'existe pas encore:
		if (Object.keys(existingStepInfo).length === 0) {
			// console.log("Creating step info: ", stepInfo);
			return await this.Create(stepInfo);
		} else {
			// console.log("Updating step info: ", stepInfo);
			return await this.Update(stepInfo);
		}
	}
}

export default new StepInfo();
